export * from './AuthPageTemplate'
